import {createSelector} from "reselect";
import {getAdminStoreState} from "../../../../store/admin-store-selectors";

export class PatientStatusTypesSelectors {
    static readonly state = createSelector(getAdminStoreState, state => state.patientStatusTypes);

    //  Sorted by the API-provided sortOrder, so dropdown display order is owned by the server.
    static readonly statusTypes = createSelector(PatientStatusTypesSelectors.state, state =>
        [...state.statusTypes].sort((left, right) => (left.sortOrder ?? 0) - (right.sortOrder ?? 0)));

    static readonly initialized = createSelector(PatientStatusTypesSelectors.state, state => state.initialized);
    static readonly error = createSelector(PatientStatusTypesSelectors.state, state => state.error);
}
